module.exports = __webpack_public_path__ + "static/forest_red-3c64e6843438b0de1ce57d78ca6427b1.gif";